import { getAxiosClient } from "../../axios-client";
import {
  UpdateUserOperatorBody, 
  UpdateUserOperatorResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const updateUserOperator = async (
  body: UpdateUserOperatorBody
) => {
  return await axiosClient.ax.put<UpdateUserOperatorResponse>(
    "/Operators/OperatorsUpdate",
    body
  );
};
